<template>
  <h5 class="mb-1 leading-none font-medium tracking-tight">
    <slot />
  </h5>
</template>
